<app-navigation-panel-container>

  <!-- Main navigation panel -->
  <app-navigation-panel [expanded]="sideMenuExpanded()" (onDragDismiss)="toggleSideMenu()">

    <div>
      <div class="flex items-center gap-x-2 pr-4">
        <div class="flex-1 px-3 py-1">
          <img src="assets/logos/logo-white.png" alt="Blume Logo" class="h-16" />
        </div>
        <app-icon-button class="lg:hidden" [config]="{
          icon: 'chevron-back-outline',
          color: 'surface',
          size: 'sm',
          border: true,
          shadow: true,
        }" (click)="toggleSideMenu()"></app-icon-button>
      </div>
    </div>

    <div class="px-4 space-y-1 pt-0">
      <div class="text-xs font-semibold text-secondary">Blume Admin</div>
      <app-wavy-divider class="block"></app-wavy-divider>
    </div>

    <div class="flex-1 space-y-6 pt-2 pb-8 font-medium">

      <!-- Admin Section -->
      <div class="px-2 pt-2">
        <div class="px-4 pb-2">
          <div class="text-xs font-bold text-[var(--ion-color-medium)]">
            Admin
          </div>
        </div>
        <div class="space-y-1">
          @for (item of adminMenuItems; track $index) {
          <app-navigation-menu-item [item]="item" (itemClick)="navigateTo($event)" [shadow]="false">
          </app-navigation-menu-item>
          }
        </div>
      </div>

      <!-- Academy Section -->
      <div class="px-2 pt-2">
        <div class="px-4 pb-2">
          <div class="text-xs font-bold text-[var(--ion-color-medium)]">
            Academy
          </div>
        </div>
        <div class="space-y-1">
          @for (item of academyMenuItems; track $index) {
          <app-navigation-menu-item [item]="item" (itemClick)="navigateTo($event)" [shadow]="false">
          </app-navigation-menu-item>
          }
        </div>
      </div>

      <!-- Apps Section -->
      <div class="px-2 pt-2">
        <div class="px-4 pb-2">
          <div class="text-xs font-bold text-[var(--ion-color-medium)]">
            Apps
          </div>
        </div>
        <div class="space-y-1">
          @for (item of appsMenuItems; track $index) {
          <app-navigation-menu-item [item]="item" (itemClick)="navigateTo($event)" [shadow]="false">
          </app-navigation-menu-item>
          }
        </div>
      </div>

    </div>

  </app-navigation-panel>

  <!-- Main content -->
  <app-navigation-panel-tabs-container [sideMenuExpanded]="sideMenuExpanded()">
    <ion-tabs></ion-tabs>
  </app-navigation-panel-tabs-container>

</app-navigation-panel-container>
